module.exports = __webpack_public_path__ + "static/media/main-stage-4-locked.d0b7605c.png";